const ContentModalSuccessEdit = () => {
  return (
    <div className="modalMessage">
      <p>Nome social do aluno(a) editado com sucesso!</p>
    </div>
  );
}

export default ContentModalSuccessEdit;